import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    CreatePrintedCategoryInput,
    PrintedCategory,
    UpdatePrintedCategoryInput
} from '@app/core/services/api/API.service';
@Injectable({
    providedIn: 'root'
})
export class PrintedCategoryService {
    private amplifyClient = generateClient();
    constructor() {}

    async listPrintedCategories(): Promise<PrintedCategory[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listPrintedCategories
                })
            ).data.listPrintedCategories.items;
            if (data) return data as PrintedCategory[];
        } catch (error) {
            console.error('Error finding PrintedCategory:', error);
            return null;
        }
    }
    async createPrintedCategory(
        input: CreatePrintedCategoryInput
    ): Promise<PrintedCategory> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: mutations.createPrintedCategory,
                    variables: {
                        input
                    }
                })
            ).data.createPrintedCategory;
            if (data) return data as PrintedCategory;
        } catch (error) {
            console.error('Error creating PrintedCategory:', error);
            return null;
        }
    }
    async updatePrintedCategory(
        input: UpdatePrintedCategoryInput
    ): Promise<PrintedCategory> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: mutations.updatePrintedCategory,
                    variables: {
                        input
                    }
                })
            ).data.updatePrintedCategory;
            if (data) return data as PrintedCategory;
        } catch (error) {
            console.error('Error creating PrintedCategory:', error);
            return null;
        }
    }
}
